import {
    Form,
    Icon,
    Input,
    Button,
    Checkbox,
    Spin,
    InputNumber,
    Tooltip,
    Row,
    Col,
    Typography,
    Descriptions,
    Divider,
    Avatar,
    Modal,
    Popover,
    Upload,
} from 'antd';
import { ExclamationCircleOutline } from '@ant-design/icons';
import { FormComponentProps } from 'antd/lib/form';
import React from 'react';
import { Redirect, RouteProps, NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import AuthContext from '../../../Context/AuthContext';
import FormControl from '../../Forms/FormControl';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import { ClientIpoHandler } from '../ClientIpoHandler';
import ValidationUtility from 'Core/ValidationUtility';
import queryString from 'query-string';
import { StyleIpoApplicationForm } from './IpoApplicationForm.Style';
import SimpleSelect from '../../Forms/SimpleSelect';
import IFilterSelectOption from '../../Forms/DataGrid/FilterSelectbox/IFilterSelectOption';
import Utility from 'Core/Utility/Utility';
import NotificationService from 'Core/NotificationService';
import DetailsMode from 'Core/models/DetailsMode';
import { WebApplicationModel, PaymentMethod, OfferingViewModel, AccountHolder, PaymentMethodDescriptionModel, ApplicationSignatureModel, OfferingType, SharePoolModel, SharePoolType, ApplicationDocumentUploadModel, PaymentInfoModel, PaymentMandate } from '../../../Core/Api/Api';
import SimpleUpload from 'components/Forms/SimpleUpload';
import DetailsData from 'Core/models/DetailsData';
import { BorderlessDescriptions } from '../../Offering/OfferingDetailsView';

import { startCase } from 'lodash';
import { LeftAlignedRow } from '../../Styled/Layout/LeftAlignedRow';
import moment from 'moment';
import ConfigService from '../../../Core/ConfigService';
import Config from '../../../Core/Config.json';
import renderHTML from 'react-render-html';
import { WhiteBackgroundCard, singleColFormColSize } from '../../Forms/Form.Styled';
import { IPOTitle } from '../../Offering/OfferingDetailsView';
import NumberFormat from 'react-number-format';
import { RightAlignedRow } from '../../Styled/Layout/RightAlignedRow';
import { BrandedButton } from '../../Styled/Branded/BrandedButton';
import TextArea from 'antd/lib/input/TextArea';
import numeral from 'numeral';
import GiftRecipientDetailsForm from './GiftRecipientDetailsForm';
import ISelectOption from '../../Forms/SimpleSelect/ISelectOption';
import { CenterAlignedRow } from '../../Styled/Layout/CenterAlignedRow';

import TcDoc from '../../../assets/Files/VMWM_IPO_System_Terms_and_Conditions.pdf';
import PrivacyDoc from '../../../assets/Files/VMWM_IPO_System_Data_Protection_Privacy_Policy.pdf';

export interface Props extends FormComponentProps, RouteComponentProps {
    children?: React.ReactNode;
    isGuestApplication?: boolean;
}

export interface State {
    offering?: OfferingViewModel;
    isConfirmed: boolean;
    accounts: any;
    sharepools: any;
    banks?: any;
    giftPools?: SharePoolModel;
    sharepoolList: any;
    selectedSharePool?: SharePoolModel;
    paymentMethods: any;
    detailsMode: DetailsMode;
    completed: boolean;
    selectedPaymentMethod?: PaymentMethod;
    amountPayable?: number;
    sharePrice?: number;
    subTotal?: number;
    serviceFee?: number;
    sharesRequested?: number;
    giftedAmount?: number;
    Dollarvalue?: any;
    applicationId?: any;
    accountId?: any;
    showModal: boolean;
    showDocumentsModal: boolean;
    showAccreditationModal: boolean;
    jointHolder1?: AccountHolder;
    jointHolder2?: AccountHolder;
    jointHolder3?: AccountHolder;
    jointHolder4?: AccountHolder;
    commentText?: string;
    paymentText?: string;
    paymentMethodDescription?: PaymentMethodDescriptionModel[];
    jmdBankDetails?: string;
    usdBankDetails?: string;
    wireTransferDetails?: string;
    showBankingInfoModal: boolean;
    noAccounts: boolean;
    disableInputs: boolean;
    uploadedDocuments: ApplicationDocumentUploadModel[];
    signatures?: ApplicationSignatureModel[];
    signature1?: ApplicationSignatureModel;
    signature2?: ApplicationSignatureModel;
    signature3?: ApplicationSignatureModel;
    signature4?: ApplicationSignatureModel;
    sharesOwned?: any;
    sharesAvailable?: any;
    accountsVirtualNumber: any;
    paymentInfo?: any;
    showFiservModal: boolean;
    isGuestApplication: boolean;
    showPaymentMandateModal: boolean;
    selectedPaymentMandate?: PaymentMandate;
    paymentMandates: any;
    showNewPaymentMandate: boolean;
    showPseudoNotice: boolean;
}

/**
 * Format the virtual account number to NNNN NNNN NNNN NNNN if it has 16 digits.
 */
function formatVirtualAccountNumber(virtualAccountNumber) {

    // Check if the virtualAccountNumber string has exactly 16 digits
    if (virtualAccountNumber.length === 16) {
        // Format the string as NNNN NNNN NNNN NNNN
        return `${virtualAccountNumber.slice(0, 4)} ${virtualAccountNumber.slice(4, 8)} ${virtualAccountNumber.slice(8, 12)} ${virtualAccountNumber.slice(12, 16)}`;
    } else {
        // Return the original input if the length is not 16
        return virtualAccountNumber;
    }
}

class IpoApplicationFormWithoutFormAndRouter extends React.Component<Props, State> {
    ipoApplicationFormHandler: ClientIpoHandler;
    config: typeof Config;
    static contextType = AuthContext;
    context!: React.ContextType<typeof AuthContext>;

    constructor(props: Props) {
        super(props);
        this.ipoApplicationFormHandler = new ClientIpoHandler(props);
        this.config = ConfigService.getSync();

        this.state = {
            isConfirmed: false,
            accounts: [],
            accountsVirtualNumber: [],
            sharepools: [],
            sharepoolList: [],
            uploadedDocuments: [],
            // selectedSharePool: [],
            paymentMethods: [],
            detailsMode: DetailsMode.New,
            //offering: [],
            completed: false,
            showModal: false,
            showDocumentsModal: false,
            showAccreditationModal: false,
            noAccounts: false,
            showBankingInfoModal: false,
            showFiservModal: false,
            disableInputs: false,
            isGuestApplication: false,
            showPaymentMandateModal: false,
            paymentMandates: [],
            showNewPaymentMandate: false,
            showPseudoNotice: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        //console.log('Guest Application: ', this.props?.isGuestApplication);
        this.getIpoDetails();
        //this.getAccounts();
        this.getPaymentMethods();
        this.getApplication();
        //this.getPaymentTypes();
        this.getBanks();
    }


    getBanks() {
        const urlState = this.props?.location?.state as DetailsData | undefined;


        if (urlState) {
            this.ipoApplicationFormHandler.GetBanks().then(x => {
                //var banks: ISelectOption[] = [];
                const banks: ISelectOption[] =
                    x.results?.map(y => ({
                        text: y.name,
                        value: y.name,
                    })) ?? [];
                //x.results?.map({ });
                this.setState({
                    banks: banks
                });
            });
        }
    }

    getPaymentTypes(currency?: string) {
        this.ipoApplicationFormHandler.GetPaymentTypes(currency).then(x => {
            this.setState({
                paymentMethodDescription: x.paymentDescriptions
            });
        });
    }
    getIpoDetails() {
        const urlState = this.props?.location?.state as DetailsData | undefined;


        if (urlState) {
            this.ipoApplicationFormHandler.GetOfferingViewModelById({ id: urlState.id }).then(x => {
                this.setState({
                    offering: x.offering,
                    showAccreditationModal: (x.offering?.requiresAccreditedInvestor ?? false)
                }, () => {
                    if (this.props?.isGuestApplication) {
                        if (urlState.mode == DetailsMode.New) {
                            this.getAccounts(urlState?.alternateId);
                        }
                    } else {
                        this.UpdateServiceFeeAndAmountPayable();
                        this.getAccounts();
                        this.getPaymentMandates();
                    }
                });

                var uploadedDocuments: ApplicationDocumentUploadModel[] = [];

                x.offering?.documents?.map((item, i) => {
                    var document = new ApplicationDocumentUploadModel();
                    document.id = item.id;
                    //console.log(document);
                    uploadedDocuments.push(document);
                });
                //console.log(uploadedDocuments);
                this.setState({ uploadedDocuments: uploadedDocuments });
                this.getPaymentTypes(x.offering?.currency);

                //this.props.form.setFieldsValue(x.user ?? {});
            });
            this.getSharePool(urlState.id);


        } else {
            this.setState({ detailsMode: DetailsMode.New });
        }
    }

    DownloadLink(fileUrl: string | undefined): void {
        Utility.downloadURI(fileUrl, '');
    }

    changeSharePool = e => {
        var selected = this.state.sharepools.find(x => x.id == e);
        this.setState(
            {
                selectedSharePool: selected,
                sharePrice: selected?.price,
            },
            () => {
                this.UpdateServiceFeeAndAmountPayable();
                this.UpdateNumberOfShares();
                if (this.state.offering?.offeringType == OfferingType.RightsIssue) {
                    this.UpdateShareAvailable();
                }
            }
        );
    };


    updateUploadedDocument = (d, e) => {
        //console.log(d);
        //console.log(e);

        //var document = this.state.uploadedDocuments.find((value, index) => { return value.id == d; });

        //if (document) {
        //    console.log(document);
        //}

        //console.log("update");
        //console.log(this.state.uploadedDocuments);

    };

    changeRequestedAmount = (e) => {
        this.setState(
            {
                sharesRequested: e.floatValue,
            },
            () => {
                this.UpdateServiceFeeAndAmountPayable();
            }
        );
    };

    //isAllowed = (values) => {
    //    var minValue = this.state.offering?.minimumQuantityValue || 1;
    //    const { formattedValue, floatValue } = values
    //    if (floatValue == null) {
    //        return formattedValue === ''
    //    } else {
    //        return (floatValue <= 15 && floatValue >= 5)
    //    }
    //};

    UpdateServiceFeeAndAmountPayable(paymentMethod?: string | undefined) {
        if (this.state.sharePrice != null && this.state.sharesRequested != null) {

            var serviceFee = 0;

            if (paymentMethod == PaymentMethod.CardPayment) {
                serviceFee = (((this.state.sharePrice ?? 0) * (this.state.sharesRequested ?? 0)) +
                    (this.state.offering?.processingFee ?? 0)) * .05;
            }
            else if (paymentMethod != PaymentMethod.CardPayment && paymentMethod != undefined) {
                serviceFee = 0;
            }
            else if (this.state.selectedPaymentMethod == PaymentMethod.CardPayment) {
                serviceFee = (((this.state.sharePrice ?? 0) * (this.state.sharesRequested ?? 0)) +
                    (this.state.offering?.processingFee ?? 0)) * .05;
            } else {
                serviceFee = 0;
            }

            this.setState({
                subTotal: (this.state.sharePrice ?? 0) * (this.state.sharesRequested ?? 0),
                serviceFee: serviceFee,
                amountPayable:
                    ((this.state.sharePrice ?? 0) * (this.state.sharesRequested ?? 0)) +
                    (this.state.offering?.processingFee ?? 0) + serviceFee,
            });
        } else {
            this.setState({ subTotal: undefined });
            this.setState({ serviceFee: undefined });
            this.setState({ amountPayable: undefined });
        }
    }

    UpdateShareAvailable() {
        if (this.state.accountId && this.state.selectedSharePool)
            this.ipoApplicationFormHandler.GetAvailableShares(this.state.accountId, this.state.selectedSharePool.id).then(x => {

                var available = x.sharesAvailable;
                var owned = x.sharesOwned;

                if (!x.found) {
                    this.props.form.resetFields(['sharesRequested', 'Dollarvalue']);
                }
                this.setState({ sharesAvailable: x.found ? available : null, sharesOwned: x.found ? owned : null, disableInputs: !x.found });

                if (!x.found) {
                    NotificationService.error(
                        'No Shares Available.',
                        <>
                            <p>This account is not allowed to apply for the selected share pool.</p>
                        </>,
                        5,
                        false
                    );
                }
            });
    }


    changeNumberofShares = (e) => {
        this.setState(
            {
                Dollarvalue: e.floatValue,
            },
            () => {
                this.UpdateNumberOfShares();
            }
        );

    };

    UpdateNumberOfShares() {
        if (this.state.Dollarvalue != null) {
            var price = (this.state.sharePrice ?? 1)

            var processingFee = this.state.offering?.processingFee ?? 0;

            var increment = this.state.offering?.shareIncrements ?? 1;
            var shareValue = Math.max(((this.state.Dollarvalue ?? 0) - processingFee), 0);
            var offset = 0;
            var value1 = shareValue / price;

            var value2 = Math.floor((value1 - offset) / increment) * increment + offset;

            this.props.form.setFieldsValue({ sharesRequested: value2 });
            this.props.form.validateFields(["sharesRequested"]);
        }
    }

    getAccounts(guestId?: string) {
        console.log(guestId);
        if (guestId) {
            this.ipoApplicationFormHandler.GetGuestAccount(guestId).then(x => {
                var accounts = [{ text: x.accountName, value: x.id }];
                this.setState({ isGuestApplication: true, accounts: accounts, noAccounts: false, accountId: x.id });
            });

        } else {
            this.ipoApplicationFormHandler.GetAccounts().then(x => {
                const accounts: IFilterSelectOption[] =
                    x.results?.map(y => ({
                        text: y.name + ' (' + y.jcsdNumber + ')' + ' - ' + y.broker?.shortName,
                        value: y.id,
                    })) ?? [];
                this.setState({ accounts: accounts ?? [], showPseudoNotice: true,  noAccounts: accounts.length == 0 });


                if (x.results && this.state.offering?.currency !== undefined) {
                    const accountsVirtualNumber = {};
                    for (const { id, accountVirtualNumbers } of x.results) {
                        var account_id = id;
                        if (account_id !== undefined && accountVirtualNumbers !== undefined) {
                            for (const { id, currency, virtualAccountNumber } of accountVirtualNumbers) {
                                if (id !== undefined && currency?.toLowerCase() === this.state.offering?.currency?.toLowerCase()) {
                                    accountsVirtualNumber[account_id] = formatVirtualAccountNumber(virtualAccountNumber);
                                    break;
                                }
                            }
                        }
                    }
                    this.setState({ accountsVirtualNumber: accountsVirtualNumber ?? [] });
                }
            });
        }
    }

    getPaymentMandates() {
        this.ipoApplicationFormHandler.GetPaymentMandates().then(x => {
            const accounts: IFilterSelectOption[] =
                x.results?.map(y => ({
                    text: y.accountNumber + ' (' + y.bank + ')',
                    value: y,
                })) ?? [];
            this.setState({ paymentMandates: accounts ?? [] });
        });
    }

    getApplication() {
        const urlState = this.props?.location?.state as DetailsData | undefined;

        if (urlState && urlState.mode == DetailsMode.Edit) {
            if (urlState.alternateId) {
                this.setState({ applicationId: urlState.alternateId });

                this.ipoApplicationFormHandler.GetApplicationById(urlState.alternateId, this.props?.isGuestApplication).then(x => {
                    if (x.isGuestApplication) {
                        this.getAccounts(x.guestUser?.id);
                        if (x.paymentMandate) {
                            this.setState({
                                paymentMandates: [
                                    //    {
                                    //    text: '-- NEW PAYMENT MANDATE --',
                                    //    value: {id: '-1'},
                                    //},
                                    {
                                        text: x.paymentMandate.accountNumber + ' (' + x.paymentMandate.bank + ')',
                                        value: x.paymentMandate,
                                    }], selectedPaymentMandate: x.paymentMandate
                            });
                        }
                    }

                    var data = {
                        accountId: this.props?.isGuestApplication ? x.guestUser?.id : x.accountId,
                        sharePoolId: x.sharePoolId,
                        paymentMethod: x.paymentMethod,
                        referenceNumber: x.referenceNumber,
                        comments: x.paymentComment,
                        sharesRequested: x.sharesRequested,
                        bankName: x.bankName,
                        branchName: x.branchName,
                        paymentMandateId: x.paymentMandate?.id,
                        paymentMandateBank: x.paymentMandate?.bank,
                        paymentMandateBranch: x.paymentMandate?.branch,
                        paymentMandateAccountNumber: x.paymentMandate?.accountNumber,
                        paymentMandateNameOnAccount: x.paymentMandate?.nameOnAccount,
                        paymentMandateAccountType: x.paymentMandate?.accountType,
                        paymentMandateCurrency: x.paymentMandate?.currency,
                    };


                    this.setState(
                        {
                            detailsMode: DetailsMode.Edit,
                            sharePrice: x.sharePool?.price,
                            sharesRequested: x.sharesRequested,
                            selectedPaymentMethod: x.paymentMethod,
                            signatures: x.signatures
                        },
                        () => {
                            this.UpdateServiceFeeAndAmountPayable();
                        }
                    );

                    this.props.form.setFieldsValue(data ?? {});
                });
            }
        }
    }

    getSharePool(ipoId: string | undefined) {
        let query = new URLSearchParams(this.props.location.search);
        this.ipoApplicationFormHandler.GetSharePools(ipoId).then(x => {
            const sharepools: IFilterSelectOption[] =
                x.sharePools?.map(y => ({
                    text: y.name,
                    value: y.id,
                })) ?? [];

            this.setState({
                sharepools: x.sharePools ?? [],
                sharepoolList: sharepools ?? [],
                giftPools: x.sharePools?.find(y => y.sharePoolType == SharePoolType.Gift)
            });

            if (query.has('sp')) {
                var sharePoolId = query.get('sp');
                this.props.form.setFieldsValue({ sharePoolId: sharePoolId });
                this.changeSharePool(sharePoolId);
            }
        });
    }

    getPaymentMethods() {
        const paymentMethodsRaw = Utility.enumToSelectionOptionArray(PaymentMethod);
        const paymentMethods = paymentMethodsRaw.filter(x => {
            if (this.props?.isGuestApplication) {
                return x.value !== PaymentMethod.BrokerageTransfer
                    && x.value !== PaymentMethod.ElectronicFundTransfer
                    && x.value !== PaymentMethod.CardPayment;
            } else {
                return x.value !== PaymentMethod.BrokerageTransfer && x.value !== PaymentMethod.CardPayment;
            }
        }).map(x => ({
            text: startCase(x.text),
            value: x.value,
        }));

        this.setState({ paymentMethods });
    }

    checkForJointApproval(values: WebApplicationModel) {
        //console.log(this.state.offering?.requiresAccreditedInvestor);
        //console.log(this.state.offering?.documents?.length);
        if ((this.state.offering?.requiresAccreditedInvestor || this.state.offering?.offeringType == OfferingType.Bonds) && (this.state.offering?.documents?.length ?? 0) > 0) {
            console.log('checkForJointApproval displaying documents');
            //console.log(this.state.uploadedDocuments);
            this.setState({ showDocumentsModal: true });
        }
        else {
            this.ipoApplicationFormHandler.GetJointHoldersForAccount(values.accountId, this.state.isGuestApplication).then(x => {
                if (x.accountHolders && (x.accountHolders?.length ?? 0) > 0) {
                    for (var i = 0; i < (x.accountHolders?.length ?? 0); i++) {
                        switch (i + 1) {
                            case 1:
                                var sig1: ApplicationSignatureModel | undefined;
                                var holder1 = x?.accountHolders[0];
                                if (holder1) {
                                    sig1 = this.state.signatures?.find(sig => sig.accountHolderId == holder1.id);
                                }
                                this.setState({ jointHolder1: x.accountHolders[0], signature1: sig1 });
                                break;
                            case 2:
                                var sig2: ApplicationSignatureModel | undefined;
                                var holder2 = x?.accountHolders[1];
                                if (holder2) {
                                    sig2 = this.state.signatures?.find(sig => sig.accountHolderId == holder2.id);
                                }
                                this.setState({ jointHolder2: x.accountHolders[1], signature2: sig2 });
                                break;
                            case 3:
                                var sig3: ApplicationSignatureModel | undefined;
                                var holder3 = x?.accountHolders[2];
                                if (holder3) {
                                    sig3 = this.state.signatures?.find(sig => sig.accountHolderId == holder3.id);
                                }
                                this.setState({ jointHolder3: x.accountHolders[2], signature3: sig3 });
                                break;
                            case 4:
                                var sig4: ApplicationSignatureModel | undefined;
                                var holder4 = x?.accountHolders[3];
                                if (holder4) {
                                    sig4 = this.state.signatures?.find(sig => sig.accountHolderId == holder4.id);
                                }
                                this.setState({ jointHolder4: x.accountHolders[3], signature4: sig4 });
                                break;
                        }
                    }

                    //if (this.state.selectedPaymentMethod != PaymentMethod.CardPayment) {
                    this.setState({ showModal: true });
                    //}
                }
                else {
                    this.sendNewApplication(values);
                }
            });
        }
    }

    sendNewApplication(values: WebApplicationModel) {

        //console.log(this.state.uploadedDocuments);
        values.currency = this.state.offering?.currency;
        values.paymentMandateId = this.state.selectedPaymentMandate?.id;

        if (values.signatureFile1) {
            values.signatureFile1 = (values.signatureFile1 ?? [undefined])[0] as any;
            values.holderId1 = this.state.jointHolder1?.id;
        }

        if (values.signatureFile2) {
            values.signatureFile2 = (values.signatureFile2 ?? [undefined])[0] as any;
            values.holderId2 = this.state.jointHolder2?.id;
        }

        if (values.signatureFile3) {
            values.signatureFile3 = (values.signatureFile3 ?? [undefined])[0] as any;
            values.holderId3 = this.state.jointHolder3?.id;
        }

        if (values.signatureFile4) {
            values.signatureFile4 = (values.signatureFile4 ?? [undefined])[0] as any;
            values.holderId4 = this.state.jointHolder4?.id;
        }

        if (this.state.uploadedDocuments) {
            //console.log('Has uploaded documents');
            //console.log(this.state.uploadedDocuments);
            //console.log(values.documents);
            //values.documents = { ...this.state.uploadedDocuments };
            if (values.documents) {
                for (var i = 0; i < values.documents.length; i++) {
                    values.documents[i].document = (values.documents[i].document ?? [undefined])[0] as any;
                    values.documents[i].id = this.state.uploadedDocuments[i].id;
                }
            }
        }

        //console.log(values.documents);

        values.paymentOrderId = this.state.paymentInfo?.orderId;
        values.amountPayable = this.state.amountPayable
        values.sharesRequested = this.state.sharesRequested;
        values.isGuestApplication = this.state.isGuestApplication;

        if (this.state.selectedPaymentMethod != undefined) {

            // Convert files list to single files
            values.proofOfPayment = (values.proofOfPayment ?? [undefined])[0] as any;
            this.ipoApplicationFormHandler.CreateOfferingApplication(values).then(x => {
                //this.props.history.goBack();
                //NotificationService.success(`IPO Application successfully submitted.`);

                //Do not show notification for card payments
                if (this.state.selectedPaymentMethod != PaymentMethod.CardPayment) {

                    NotificationService.success(
                        'Success.',
                        <>
                            <p>Your IPO Application has been successfully submitted. Your application number is {x.referenceNumber}.</p>
                        </>,
                        undefined,
                        true
                    );

                    this.setState({ completed: true });
                } else if (this.state.selectedPaymentMethod == PaymentMethod.CardPayment) {
                    this.ipoApplicationFormHandler.GetFiservInfo(x.referenceNumber, this.state.amountPayable, this.state.offering?.currency).then(y => {
                        //console.log(y);
                        this.setState({ showModal: true, paymentInfo: y.paymentInfo }, () => {

                            //Show showFiservModal modal after showModal is closed
                            this.setState({ showFiservModal: true, showModal: false });
                        });
                    });

                }
            });
        } else {
            // Convert files list to single files
            values.proofOfPayment = (values.proofOfPayment ?? [undefined])[0] as any;
            this.ipoApplicationFormHandler.SaveDraftApplication(values).then(x => {
                //this.props.history.goBack();
                //NotificationService.success(`IPO Application successfully submitted.`);
                NotificationService.success(
                    'Success.',
                    <>
                        <p>Your IPO Application has been saved successfully. Your application number is {x.referenceNumber}.</p>
                    </>,
                    undefined,
                    true
                );

                this.setState({ completed: true });
            });
        }

    }

    saveDraftApplication(values: WebApplicationModel) {

        values.paymentMandateId = this.state.selectedPaymentMandate?.id;

        if (values.signatureFile1) {
            values.signatureFile1 = (values.signatureFile1 ?? [undefined])[0] as any;
            values.holderId1 = this.state.jointHolder1?.id;
        }

        if (values.signatureFile2) {
            values.signatureFile2 = (values.signatureFile2 ?? [undefined])[0] as any;
            values.holderId2 = this.state.jointHolder2?.id;
        }

        if (values.signatureFile3) {
            values.signatureFile3 = (values.signatureFile3 ?? [undefined])[0] as any;
            values.holderId3 = this.state.jointHolder3?.id;
        }

        if (values.signatureFile4) {
            values.signatureFile4 = (values.signatureFile4 ?? [undefined])[0] as any;
            values.holderId4 = this.state.jointHolder4?.id;
        }

        values.amountPayable = this.state.amountPayable
        values.sharesRequested = this.state.sharesRequested;
        this.ipoApplicationFormHandler.SaveDraftApplication(values).then(x => {
            //this.props.history.goBack();
            //NotificationService.success(`IPO Application successfully submitted.`);

            if (this.state.selectedPaymentMethod == PaymentMethod.CardPayment) {
                this.ipoApplicationFormHandler.GetFiservInfo(x.referenceNumber, this.state.amountPayable, this.state.offering?.currency).then(y => {
                    //console.log(y);
                    this.setState({ showModal: true, paymentInfo: y.paymentInfo });
                });
            }
            else {
                NotificationService.success(
                    'Success.',
                    <>
                        <p>Your IPO Application has been saved successfully. Your application number is {x.referenceNumber}.</p>
                    </>,
                    undefined,
                    true
                );
            }

            this.setState({ completed: true });
        });

    }

    handlePaymentReview() {
        console.log('handlePaymentReview displaying documents');

        this.setState({ showDocumentsModal: true, showPaymentMandateModal: false });
    }

    createApplication(values: WebApplicationModel) {
        //this.checkForJointApproval(values);
        this.checkForJointApproval(values);
    }

    formSubmit(e: React.FormEvent) {
        if (this.state.selectedPaymentMethod != undefined) {
            console.log('formSubmit displaying documents');
            this.setState({ showDocumentsModal: true });
            // this.setState({ showPaymentMandateModal: true });
            //this.handleSubmit(e);
        } else {
            this.handleDraftSave(e);
        }
    }

    handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        const query = queryString.parse(this.props?.location?.search);

        const stepOneFields: string[] = ["agreement", "privacyAgreement", "sharesRequested", "proofOfPayment",
            "comments", "branchName", "bankName", "referenceNumber", "description", "paymentMethod",
            "sharePoolId", "accountId"];

        this.props.form.validateFieldsAndScroll(stepOneFields, (error, values: WebApplicationModel) => {
            values.offeringId = this.state.offering?.id;
            if (error) {
                //console.log(this.state.offering?.documents);
                //console.log('handleSubmit displaying documents');
                //this.setState({ showDocumentsModal: true });
                return;

            }

            if (this.state.detailsMode == DetailsMode.Edit) {

                values.applicationId = this.state.applicationId;

                values.sharesRequested = this.state.sharesRequested;
                // Convert files list to single files
                values.proofOfPayment = (values.proofOfPayment ?? [undefined])[0] as any;
                this.ipoApplicationFormHandler.GetJointHoldersForAccount(values.accountId, this.state.isGuestApplication).then(x => {
                    if (x.accountHolders && (x.accountHolders?.length ?? 0) > 0) {
                        for (var i = 0; i < (x.accountHolders?.length ?? 0); i++) {
                            switch (i + 1) {
                                case 1:
                                    this.setState({ jointHolder1: x.accountHolders[0] });
                                    break;
                                case 2:
                                    this.setState({ jointHolder2: x.accountHolders[1] });
                                    break;
                                case 3:
                                    this.setState({ jointHolder3: x.accountHolders[2] });
                                    break;
                                case 4:
                                    this.setState({ jointHolder4: x.accountHolders[3] });
                                    break;
                            }
                        }


                        if (this.state.selectedPaymentMethod != PaymentMethod.CardPayment) {
                            this.setState({ showModal: true });
                        }
                    }

                });


                // values.id = this.state.offering?.id;
                // this.handler.EditRole(values).then(x => {
                //   this.props.history.goBack();
                //   NotificationService.success(`Updated ${x.role?.name}`);
                // });
            } else {
                //console.log("create1");

                this.createApplication(values);

            }
        });
    }

    handleDraftSave(e: React.FormEvent) {
        e.preventDefault();

        const stepOneFields: string[] = ["agreement", "privacyAgreement", "sharesRequested", "proofOfPayment",
            "comments", "branchName", "bankName", "referenceNumber", "description", "paymentMethod",
            "sharePoolId", "accountId"];

        this.props.form.validateFieldsAndScroll(stepOneFields, (error, values: WebApplicationModel) => {
            values.offeringId = this.state.offering?.id;
            if (error) {
                return;
            }

            // Convert files list to single files
            //values.logo = (values.logo ?? [undefined])[0] as any;

            if (this.state.detailsMode == DetailsMode.Edit) {
                values.applicationId = this.state.applicationId;
                values.amountPayable = this.state.amountPayable
                values.sharesRequested = this.state.sharesRequested;
                values.isGuestApplication = this.state.isGuestApplication;

                this.ipoApplicationFormHandler.EditOfferingApplication(values).then(x => {
                    //this.props.history.goBack();
                    //NotificationService.success(`IPO Application successfully submitted.`);
                    NotificationService.success(
                        'Success.',
                        <>
                            <p>Your IPO Application has been successfully submitted.</p>
                        </>,
                        undefined,
                        true
                    );

                    this.setState({ completed: true });
                });

                // values.id = this.state.offering?.id;
                // this.handler.EditRole(values).then(x => {
                //   this.props.history.goBack();
                //   NotificationService.success(`Updated ${x.role?.name}`);
                // });
            } else {

                this.ipoApplicationFormHandler.GetJointHoldersForAccount(values.accountId, this.state.isGuestApplication).then(x => {
                    if (x.accountHolders && (x.accountHolders?.length ?? 0) > 0) {
                        for (var i = 0; i < (x.accountHolders?.length ?? 0); i++) {
                            switch (i + 1) {
                                case 1:
                                    this.setState({ jointHolder1: x.accountHolders[0] });
                                    break;
                                case 2:
                                    this.setState({ jointHolder2: x.accountHolders[1] });
                                    break;
                                case 3:
                                    this.setState({ jointHolder3: x.accountHolders[2] });
                                    break;
                                case 4:
                                    this.setState({ jointHolder4: x.accountHolders[3] });
                                    break;
                            }
                        }

                        this.setState({ showModal: true });
                    }
                    else {
                        this.saveDraftApplication(values);
                    }
                });


            }
        });
    }

    changePaymentMethod = e => {
        this.props.form.resetFields(['referenceNumber', 'proofOfPayment']);

        this.setState({
            selectedPaymentMethod: e,
        }, () => {
            this.getPaymentDescription();
            this.UpdateServiceFeeAndAmountPayable(e);
        });

    };

    changePaymentMandate = e => {
        this.props.form.resetFields(['mandateAcctNumber', 'mandateName', 'mandateBankBranch', 'mandateBankName']);

        //console.log(e);
        this.setState({
            selectedPaymentMandate: e,
            showNewPaymentMandate: false
        }, () => {
        });

    };

    accountChanged = e => {
        this.setState({
            jointHolder1: undefined,
            jointHolder2: undefined,
            jointHolder3: undefined,
            jointHolder4: undefined,
            accountId: e
        }, () => {
            if (this.state.offering?.offeringType == OfferingType.RightsIssue) {
                this.UpdateShareAvailable();
            }
            this.getPaymentDescription()
        });

        this.props.form.resetFields(['signature1', 'signature2', 'signature3', 'signature4']);
    }

    getPaymentDescription() {
        this.setState({ jmdBankDetails: undefined, usdBankDetails: undefined });

        var text = "";
        var currentPaymentMethod = this.state.selectedPaymentMethod;
        var description = this.state.paymentMethodDescription?.filter(x => {
            if (x?.paymentType == currentPaymentMethod) {
                return x;
            }
        });

        if (description != null && (description?.length ?? 0) > 0) {
            text = (description[0]?.description ?? "").replace('{account_number}', this.state.accountsVirtualNumber[this.state.accountId]);

            this.setState({
                jmdBankDetails: description[0]?.bankDetailJMD?.replace('{account_number}', this.state.accountsVirtualNumber[this.state.accountId]), usdBankDetails: description[0]?.bankDetailUSD?.replace('{account_number}', this.state.accountsVirtualNumber[this.state.accountId]), wireTransferDetails: description[0]?.wireTransferDetails?.replace('{account_number}', this.state.accountsVirtualNumber[this.state.accountId])
            });
        }

        switch (this.state.selectedPaymentMethod) {
            case PaymentMethod.ElectronicFundTransfer:

                this.setState({ commentText: undefined });
                break;
            case PaymentMethod.BrokerageTransfer:

                this.setState({ commentText: "Indicate the name of your broker" });
                break;
            case PaymentMethod.MarginLoans:


                this.setState({ commentText: "Contact your wealth advisor to initiate process. They will send the Capital Markets Team the verification." });
                break;
            //case PaymentMethod.OnlineTransfer:

            //    this.setState({ commentText: undefined });
            //    break;
            case PaymentMethod.VMWealthSettlement:

                this.setState({ commentText: "Contact your wealth advisor to initiate process. They will send the Capital Markets Team the verification. " });
                break;
        }

        this.setState({ paymentText: text });
    }

    showBankingInfo = () => {
        this.setState({
            showBankingInfoModal: true,
        })
    };

    getFiserv = (event: React.SyntheticEvent) => {
        //event.preventDefault();
        console.log("TEst");
        console.log(event);

        //return false;
    }

    handleOk = (event: React.SyntheticEvent) => {

        //if confirmed do this
        //this.handler.UploadRemoveStudentFile().then(x => {
        //    NotificationService.success(`Uploaded Parent File. Will be processed`, null, 0);
        //    //this.setState({ importSummary: x.importReview });
        //});
        console.log(this.state.uploadedDocuments);

        this.props.form.validateFieldsAndScroll((error, values: any) => {
            values.offeringId = this.state.offering?.id;

            if (error) {
                return;
            }
            if (this.state.detailsMode == DetailsMode.Edit) {
                values.applicationId = this.state.applicationId;
                values.amountPayable = this.state.amountPayable
                values.sharesRequested = this.state.sharesRequested;
                values.isGuestApplication = this.state.isGuestApplication;
                // Convert files list to single files
                values.proofOfPayment = (values.proofOfPayment ?? [undefined])[0] as any;
                this.ipoApplicationFormHandler.EditOfferingApplication(values).then(x => {
                    //this.props.history.goBack();
                    //NotificationService.success(`IPO Application successfully submitted.`);
                    NotificationService.success(
                        'Success.',
                        this.state.selectedPaymentMethod != undefined ?
                            <>
                                <p>Your IPO Application has been successfully submitted.</p>
                            </> : <>
                                <p>Your IPO Application has been updated successfully.</p>
                            </>,
                        undefined,
                        true
                    );

                    if (this.state.selectedPaymentMethod != PaymentMethod.CardPayment) {
                        this.setState({ completed: true });
                    } else {
                        this.setState({ showFiservModal: true, showModal: false });
                    }
                    //this.setState({ completed: true });
                });
            }
            else {

                //console.log("REG");
                //console.log(this.state.uploadedDocuments);

                this.sendNewApplication(values);
            }
        });
    }

    handleAccreditationOk = (event: React.SyntheticEvent) => {

        //if confirmed do this
        //this.handler.UploadRemoveStudentFile().then(x => {
        //    NotificationService.success(`Uploaded Parent File. Will be processed`, null, 0);
        //    //this.setState({ importSummary: x.importReview });
        //});

        //console.log('accredit Before');
        //console.log(this.state.uploadedDocuments, this, this.state);

        this.props.form.validateFieldsAndScroll((error, values: any) => {
            values.offeringId = this.state.offering?.id;

            if (error) {
                return;
            }
            if (this.state.detailsMode == DetailsMode.Edit) {
                values.applicationId = this.state.applicationId;
                values.amountPayable = this.state.amountPayable
                values.sharesRequested = this.state.sharesRequested;
                values.isGuestApplication = this.state.isGuestApplication;
                // Convert files list to single files
                values.proofOfPayment = (values.proofOfPayment ?? [undefined])[0] as any;
                this.ipoApplicationFormHandler.EditOfferingApplication(values).then(x => {
                    //this.props.history.goBack();
                    //NotificationService.success(`IPO Application successfully submitted.`);
                    NotificationService.success(
                        'Success.',
                        this.state.selectedPaymentMethod != undefined ?
                            <>
                                <p>Your IPO Application has been successfully submitted.</p>
                            </> : <>
                                <p>Your IPO Application has been updated successfully.</p>
                            </>,
                        undefined,
                        true
                    );

                    this.setState({ completed: true });
                });
            }
            else {
                //console.log('accredit');
                //console.log(this.state.uploadedDocuments);

                this.sendNewApplication(values);
            }
        });
    }

    handleCancel = (event: React.SyntheticEvent) => {
        this.setState({ showModal: false, showBankingInfoModal: false, showPseudoNotice: false, noAccounts: false, showDocumentsModal: false, showAccreditationModal: false, showFiservModal: false });
    }

    getSharePoolAllocation = (item: any) => {
        //console.log('trigger');
        //console.log(item);
        var total: number = 0;

        item?.forEach(
            x => (total = Number.parseInt(total as any) + Number.parseInt(x.numberOfShares! as any))
        );
        //console.log(total);

        this.setState({ giftedAmount: total });
    }


    render() {
        const { getFieldDecorator } = this.props.form;
        let state: { from?: any; noPermission?: boolean } = {};

        if (this.props.location) {
            state = this.props.location.state || {};
        }

        if (this.state.completed) {
            return <Redirect to="/ipo" />;
        }

        return (
            <Row type="flex" justify="center">
                <Col xs={24} sm={{ span: 22, offset: 1 }}>
                    <WhiteBackgroundCard>

                        <Modal
                            width="70%"
                            title="Banking Info"
                            visible={this.state.noAccounts}
                            onCancel={this.handleCancel}
                            footer={[
                                <Button key="back" onClick={this.handleCancel}>
                                    Close
                                </Button>
                            ]} >
                            You need to register a JCSD account to proceed

                        </Modal>

                        <Modal
                            width="70%"
                            title="Banking Info"
                            visible={this.state.showBankingInfoModal}
                            onCancel={this.handleCancel}
                            footer={[
                                <Button key="back" onClick={this.handleCancel}>
                                    Close
                                </Button>
                            ]} >
                            <Row>
                                {this.state.jmdBankDetails ? <Col xs={24} md={12}><Title >JMD Bank Information</Title>{this.state.jmdBankDetails.split('\n').slice(1)?.map(x => <p style={{ color: 'black' }}>{x}</p>)} </Col> : ''}
                                {this.state.usdBankDetails ? <Col xs={24} md={12}> <Title >USD Bank Information</Title> {this.state.usdBankDetails.split('\n').slice(1)?.map(x => <p style={{ color: 'black' }}>{x}</p>)} </Col> : ''}
                                {this.state.wireTransferDetails ? <Col xs={24} md={12}> <Title >Wire Instructions</Title> {this.state.wireTransferDetails.split('\n').slice(1)?.map(x => <p style={{ color: 'black' }}>{x}</p>)} </Col> : ''}
                            </Row>
                        </Modal>
                        <LeftAlignedRow>
                            <Col xs={24}>
                                <IPOTitle>{this.state.offering?.title}</IPOTitle>
                            </Col>
                        </LeftAlignedRow>
                        <Row type="flex">
                            <Col xs={24} sm={7}>
                                <LeftAlignedRow>
                                    <Col xs={24}>
                                        <Row>
                                            <Col>
                                                <Avatar size={128} src={this.state.offering?.logo?.fileUrl} />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Divider />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Descriptions column={2}>
                                                    <Descriptions.Item span={2} label="Short Name">
                                                        <div style={{ fontWeight: 'bolder' }}>
                                                            {this.state.offering?.shortName}
                                                        </div>
                                                    </Descriptions.Item>
                                                    <Descriptions.Item span={2} label="Arranger">
                                                        <div style={{ fontWeight: 'bolder' }}>
                                                            {this.state.offering?.arrangerName}
                                                        </div>
                                                    </Descriptions.Item>
                                                    <Descriptions.Item span={2} label="Lead Broker">
                                                        <div style={{ fontWeight: 'bolder' }}>
                                                            {this.state.offering?.leadBrokerName}
                                                        </div>
                                                    </Descriptions.Item>
                                                    {

                                                        ((this.state.offering?.coBrokersNames?.length ?? 0) > 0) ?
                                                            <>
                                                                <Descriptions.Item span={2} label="Co Brokers">
                                                                    {''}
                                                                </Descriptions.Item>
                                                                <Descriptions.Item span={2}>
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.offering?.coBrokersNames?.map(x => (
                                                                            <>
                                                                                <span> {x} </span>
                                                                                <br />
                                                                            </>
                                                                        ))}
                                                                    </div>
                                                                </Descriptions.Item>
                                                            </> : ''
                                                    }

                                                    <Descriptions.Item span={2} label="Currency">
                                                        <div style={{ fontWeight: 'bolder' }}>
                                                            {this.state.offering?.currency}
                                                        </div>
                                                    </Descriptions.Item>

                                                    <Descriptions.Item span={2} label="Minimum Quantity">
                                                        <div style={{ fontWeight: 'bolder' }}>
                                                            <NumberFormat
                                                                value={this.state.offering?.minimumQuantityValue}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                decimalScale={0}
                                                                fixedDecimalScale={true}
                                                            />
                                                        </div>
                                                    </Descriptions.Item>
                                                    <Descriptions.Item span={2} label="Share Increments">
                                                        <div style={{ fontWeight: 'bolder' }}>
                                                            <NumberFormat
                                                                value={this.state.offering?.shareIncrements}
                                                                displayType={'text'}
                                                                thousandSeparator={true}
                                                                decimalScale={0}
                                                                fixedDecimalScale={true}
                                                            />
                                                        </div>
                                                    </Descriptions.Item>

                                                    <Descriptions.Item span={2} label="Open Date">
                                                        <div style={{ fontWeight: 'bolder' }}>
                                                            <Typography.Text underline={true}>
                                                                {Utility.renderDateWithReference(
                                                                    moment(this.state.offering?.openingDate),
                                                                    this.config.Display.DateFormat
                                                                )}
                                                            </Typography.Text>
                                                        </div>
                                                    </Descriptions.Item>
                                                    <Descriptions.Item span={2} label="Closing Date">
                                                        <div style={{ fontWeight: 'bolder' }}>
                                                            <Typography.Text underline={true}>
                                                                {Utility.renderDateWithReference(
                                                                    moment(this.state.offering?.closingDate),
                                                                    this.config.Display.DateFormat
                                                                )}
                                                            </Typography.Text>
                                                        </div>
                                                    </Descriptions.Item>.

                                                </Descriptions>
                                            </Col>
                                        </Row>
                                    </Col>
                                </LeftAlignedRow>
                            </Col>
                            <Col xs={24} sm={{ offset: 1, span: 16 }}>
                                <LeftAlignedRow>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <Typography.Title type="secondary" style={{ fontWeight: 'bolder', color: 'black' }} level={3}>
                                                    Application
                                                </Typography.Title>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <StyleIpoApplicationForm
                                                    labelCol={{ sm: 7 }}
                                                    wrapperCol={{ sm: 16 }}
                                                    onSubmit={this.handleSubmit}
                                                    layout="horizontal">
                                                    <Row>
                                                        <Col span={23} >
                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[...ValidationUtility.required('Account is required')]}
                                                                name="accountId" //getFieldDecorator(name: { hidden: true })
                                                                label="Account">
                                                                <SimpleSelect showSearch={false}
                                                                    options={this.state.accounts}
                                                                    onChange={this.accountChanged}
                                                                    placeholder="Please select an account"></SimpleSelect>
                                                            </FormControl>
                                                        </Col>

                                                    </Row>
                                                    <Row>
                                                        <Col span={23} >
                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[...ValidationUtility.required('Share Pool is required')]}
                                                                name="sharePoolId" //getFieldDecorator(name: { hidden: true })
                                                                label={this.state.offering?.sharePoolCategoryName ?? "Share Pool"}>
                                                                <SimpleSelect
                                                                    onChange={this.changeSharePool}
                                                                    options={this.state.sharepoolList}
                                                                    placeholder="Please select Share Pool"
                                                                ></SimpleSelect>

                                                            </FormControl>
                                                        </Col>
                                                        <Col span={1}>
                                                            <div style={{ marginTop: '8px' }} >
                                                                <Popover placement="topLeft" title={''} content={'Share Pool'} trigger="click">
                                                                    <Icon type="question-circle" />
                                                                </Popover>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {this.state.offering?.offeringType == OfferingType.RightsIssue && this.state.sharesAvailable != null ?
                                                        <>
                                                            <Row>
                                                                <Col span={23} >
                                                                    <RightAlignedRow style={{ marginBottom: '24px' }}>
                                                                        <Col span={7} >
                                                                            <p>
                                                                                Shares Available :
                                                                            </p>
                                                                        </Col>
                                                                        <Col span={16} style={{ fontWeight: 'bolder', color: 'black' }}>
                                                                            <div className="amount-payable">
                                                                                <NumberFormat
                                                                                    style={{ textAlign: 'left' }}
                                                                                    value={this.state.sharesAvailable ?? 0}
                                                                                    displayType={'text'}
                                                                                    thousandSeparator={true}
                                                                                    decimalScale={0}
                                                                                    fixedDecimalScale={true}
                                                                                />
                                                                            </div>
                                                                        </Col>
                                                                    </RightAlignedRow>
                                                                </Col>
                                                            </Row>
                                                        </> : ''
                                                    }
                                                    <Row>
                                                        {false ? <><Col xs={23}  >
                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[

                                                                ]}
                                                                name="Dollarvalue" //getFieldDecorator(name: { hidden: true })
                                                                label="Dollar Value">
                                                                <NumberFormat displayType={'input'} type={'text'} thousandSeparator={true} decimalScale={2} className={'ant-input'}
                                                                    onValueChange={this.changeNumberofShares}
                                                                    step={this.state.offering?.shareIncrements}
                                                                    min={this.state.offering?.minimumQuantityValue || 1}
                                                                    disabled={this.state.disableInputs}
                                                                />

                                                            </FormControl>
                                                        </Col>
                                                            <Col xs={24} style={{ textAlign: 'center', paddingBottom: '10px' }}> <Title level={4}>- OR -</Title>
                                                            </Col></> : ''}


                                                        <Col xs={23}  >
                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[...ValidationUtility.required('Number of Shares is required'),
                                                                {
                                                                    min: (this.state.offering?.minimumQuantityValue ?? 1),
                                                                    type: 'number',
                                                                    message: 'Minimum Quantity allowed is ' + (this.state.offering?.minimumQuantityValue ?? 1) + '.',
                                                                    transform: value => (numeral(value as any).value() ?? 0),
                                                                },
                                                                {
                                                                    max: (this.state.sharesAvailable),
                                                                    type: 'number',
                                                                    message: 'Maximum Quantity allowed is ' + (this.state.sharesAvailable) + '.',
                                                                    transform: value => (numeral(value as any).value() ?? 0),
                                                                },

                                                                {
                                                                    required: true,
                                                                    type: 'boolean',
                                                                    message: 'Share Increment violation.',
                                                                    transform: value => { var x = ((numeral(value as any).value() ?? 0) % (this.state.offering?.shareIncrements ?? 0) == 0); return x || undefined; },
                                                                },
                                                                ]}
                                                                name="sharesRequested" //getFieldDecorator(name: { hidden: true })
                                                                label="# of Shares">
                                                                <NumberFormat displayType={'input'} type={'text'} thousandSeparator={true} decimalScale={0} className={'ant-input'}
                                                                    onValueChange={this.changeRequestedAmount}
                                                                    step={this.state.offering?.shareIncrements}
                                                                    min={this.state.offering?.minimumQuantityValue || 1}
                                                                    max={this.state.sharesAvailable}
                                                                    disabled={this.state.disableInputs}
                                                                />


                                                            </FormControl>
                                                        </Col>

                                                        <Col xs={1}>
                                                            <div style={{ marginTop: '8px' }} >
                                                                <Popover placement="topLeft" title={''} content={'Number of Shares'} trigger="click">
                                                                    <Icon type="question-circle" />
                                                                </Popover>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    {this.state.offering?.offeringType == OfferingType.RightsIssue ?
                                                        <>
                                                            {this.state.sharesAvailable && this.state.sharesRequested &&
                                                                ((this.state.sharesAvailable ?? 0) - (this.state.sharesRequested ?? 0)) > 0
                                                                ? <>
                                                                    {(this.state.offering?.offeringHasGiftPool && this.state.selectedSharePool?.sharePoolType == SharePoolType.RightsIssue) ?
                                                                        <Row>
                                                                            <Col xs={0} md={4}  >
                                                                            </Col>
                                                                            <Col xs={23} md={20} style={{ fontWeight: 'bolder', color: 'black' }} >
                                                                                <FormControl
                                                                                    getFieldDecorator={getFieldDecorator}
                                                                                    name="giftedShares"
                                                                                    label="">
                                                                                    <GiftRecipientDetailsForm
                                                                                        totalAllocation={(this.state.sharesAvailable ?? 0) - (this.state.sharesRequested ?? 0)}
                                                                                        offeringId={this.state.offering?.id}
                                                                                        mode={this.state.detailsMode}
                                                                                        onChange={this.getSharePoolAllocation}
                                                                                        offeringType={this.props.form.getFieldValue('offeringType')}
                                                                                        sharePoolName={this.state.giftPools?.name}
                                                                                    />
                                                                                </FormControl>
                                                                            </Col>
                                                                        </Row> : ''}

                                                                    {(this.state.selectedSharePool?.sharePoolType == SharePoolType.RightsIssue ||
                                                                        this.state.selectedSharePool?.sharePoolType == SharePoolType.Gift) ?
                                                                        <Row>
                                                                            <Col span={23} style={{ fontWeight: 'bolder', color: 'black' }} >
                                                                                <RightAlignedRow style={{ marginBottom: '24px' }}>
                                                                                    <Col span={7} >
                                                                                        <label>
                                                                                            Shares Renounced:
                                                                                        </label>
                                                                                    </Col>
                                                                                    <Col span={16}>
                                                                                        <div className="amount-payable">
                                                                                            <NumberFormat
                                                                                                style={{ textAlign: 'left' }}
                                                                                                value={(this.state.sharesAvailable ?? 0) - (this.state.giftedAmount ?? 0) - (this.state.sharesRequested ?? 0)}
                                                                                                displayType={'text'}
                                                                                                thousandSeparator={true}
                                                                                                decimalScale={0}
                                                                                                fixedDecimalScale={true}
                                                                                            />
                                                                                        </div>
                                                                                    </Col>
                                                                                </RightAlignedRow>
                                                                            </Col>
                                                                        </Row>
                                                                        : ''
                                                                    }
                                                                </>
                                                                : ''
                                                            }
                                                        </>

                                                        : ''}
                                                    <Row>
                                                        <Col span={23} style={{ fontWeight: 'bolder', color: 'black' }} >
                                                            <RightAlignedRow style={{ marginBottom: '24px' }}>
                                                                <Col span={9} >
                                                                    <label>

                                                                        Unit Price :
                                                                    </label>
                                                                </Col>
                                                                <Col span={14}>
                                                                    <div className="amount-payable">
                                                                        <NumberFormat
                                                                            style={{ textAlign: 'left' }}
                                                                            value={this.state.sharePrice}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            prefix={(this.state.offering?.currency ?? '') + ' $'}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </RightAlignedRow>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col span={23} style={{ fontWeight: 'bolder', color: 'black' }} >
                                                            <RightAlignedRow style={{ marginBottom: '24px' }}>
                                                                <Col span={9} >
                                                                    <label>

                                                                        Sub Total :
                                                                    </label>
                                                                </Col>
                                                                <Col span={14}>
                                                                    <div className="amount-payable">
                                                                        <NumberFormat
                                                                            style={{ textAlign: 'left' }}
                                                                            value={this.state.subTotal}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            prefix={(this.state.offering?.currency ?? '') + ' $'}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </RightAlignedRow>
                                                        </Col>
                                                    </Row>

                                                    <Row>
                                                        <Col span={23} style={{ fontWeight: 'bolder', color: 'black' }} >
                                                            <RightAlignedRow style={{ marginBottom: '24px' }}>
                                                                <Col span={9} >
                                                                    <label>
                                                                        Processing Fee :
                                                                    </label>
                                                                </Col>
                                                                <Col span={14}>
                                                                    <div className="amount-payable">
                                                                        <NumberFormat
                                                                            style={{ textAlign: 'left' }}
                                                                            value={this.state.offering?.processingFee}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            prefix={(this.state.offering?.currency ?? '') + ' $'}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </RightAlignedRow>
                                                        </Col>
                                                    </Row>

                                                    <div style={this.state.selectedPaymentMethod == PaymentMethod.CardPayment ? {} : { display: 'none' }}>
                                                        <Row>
                                                            <Col span={23} style={{ fontWeight: 'bolder', color: 'black' }} >
                                                                <RightAlignedRow style={{ marginBottom: '24px' }}>
                                                                    <Col span={9} >
                                                                        <label style={{ marginRight: '5px' }}>
                                                                            Service Fee (5%)
                                                                        </label>
                                                                        <Tooltip placement="top" title="The service fee covers bank fees, payment agent and processing network fees to ensure the safety and secure of your transaction. Please understand VM Wealth Management does not receive any portion of these fees">
                                                                            <Icon type="info-circle" />
                                                                        </Tooltip>
                                                                        <label> :</label>
                                                                    </Col>
                                                                    <Col span={14}>
                                                                        <div className="amount-payable">
                                                                            <NumberFormat
                                                                                style={{ textAlign: 'left' }}
                                                                                value={this.state.serviceFee}
                                                                                displayType={'text'}
                                                                                thousandSeparator={true}
                                                                                decimalScale={2}
                                                                                fixedDecimalScale={true}
                                                                                prefix={(this.state.offering?.currency ?? '') + ' $'}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </RightAlignedRow>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                    <Row>
                                                        <Col span={23} style={{ fontWeight: 'bolder', color: 'black' }}>
                                                            <RightAlignedRow style={{ marginBottom: '24px' }}>
                                                                <Col span={9}>
                                                                    <label>
                                                                        Amount Payable :
                                                                    </label>
                                                                </Col>
                                                                <Col span={14}>
                                                                    <div className="amount-payable">
                                                                        <NumberFormat
                                                                            style={{ textAlign: 'left' }}
                                                                            value={this.state.amountPayable}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true}
                                                                            decimalScale={2}
                                                                            fixedDecimalScale={true}
                                                                            prefix={(this.state.offering?.currency ?? '') + ' $'}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </RightAlignedRow>
                                                        </Col>
                                                    </Row>
                                                    <FormControl
                                                        getFieldDecorator={getFieldDecorator}
                                                        //rules={[...ValidationUtility.required('Payment Method is required')]}
                                                        name="paymentMethod" //getFieldDecorator(name: { hidden: true })
                                                        label="Payment Method">
                                                        <SimpleSelect
                                                            disabled={!this.state.accountId}
                                                            onChange={this.changePaymentMethod}
                                                            options={this.state.paymentMethods}
                                                            placeholder="Please select payment method"></SimpleSelect>
                                                    </FormControl>

                                                    <div style={this.state.selectedPaymentMethod ? {} : { display: 'none' }}>
                                                        <FormControl
                                                            getFieldDecorator={getFieldDecorator}
                                                            //rules={[...ValidationUtility.required('Payment Method is required')]}
                                                            name="description" //getFieldDecorator(name: { hidden: true })
                                                            label="Description"
                                                        >
                                                            <p className="text-content-justified" style={{ whiteSpace: 'pre-wrap' }}>
                                                                {/*{this.state.paymentText} {(this.state.jmdBankDetails || this.state.usdBankDetails) ? <a href="#" onClick={this.showBankingInfo}>Click here for bank info </a> : ''}*/}
                                                                {this.state.paymentText} {(this.state.jmdBankDetails || this.state.usdBankDetails) ? '' : ''}
                                                            </p>
                                                        </FormControl>
                                                    </div>

                                                    {/*<div style={this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.OnlineTransfer ? {} : { display: 'none' }}>*/}
                                                    <div style={this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.Transfer ? {} : { display: 'none' }}>
                                                        <FormControl
                                                            getFieldDecorator={getFieldDecorator}
                                                            rules={[
                                                                ...ValidationUtility.If(
                                                                    /*this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.OnlineTransfer,*/
                                                                    this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.Transfer,
                                                                    ValidationUtility.required('Reference Number is required')
                                                                ),
                                                            ]}
                                                            name="referenceNumber" //getFieldDecorator(name: { hidden: true })
                                                            label="Reference Number">
                                                            <Input />
                                                        </FormControl>
                                                    </div>
                                                    {/*<div style={this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.OnlineTransfer ? {} : { display: 'none' }}>*/}
                                                    <div style={this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.Transfer ? {} : { display: 'none' }}>
                                                        <FormControl
                                                            getFieldDecorator={getFieldDecorator}
                                                            rules={[
                                                                ...ValidationUtility.If(
                                                                    /*this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.OnlineTransfer,*/
                                                                    this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.Transfer,
                                                                    ValidationUtility.required('Bank Name is required')
                                                                ),
                                                            ]}
                                                            name="bankName" //getFieldDecorator(name: { hidden: true })
                                                            label="Bank Name">
                                                            <Input />
                                                        </FormControl>
                                                    </div>
                                                    <div style={this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.Transfer ? {} : { display: 'none' }}>
                                                        <FormControl
                                                            getFieldDecorator={getFieldDecorator}
                                                            rules={[
                                                                ...ValidationUtility.If(
                                                                    this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.Transfer,
                                                                    ValidationUtility.required('Branch Name is required')
                                                                ),
                                                            ]}
                                                            name="branchName" //getFieldDecorator(name: { hidden: true })
                                                            label="Branch Name">
                                                            <Input />
                                                        </FormControl>
                                                    </div>
                                                    <div style={this.state.selectedPaymentMethod == PaymentMethod.BrokerageTransfer || this.state.selectedPaymentMethod == PaymentMethod.MarginLoans || this.state.selectedPaymentMethod == PaymentMethod.VMWealthSettlement ? {} : { display: 'none' }}>
                                                        <FormControl
                                                            getFieldDecorator={getFieldDecorator}
                                                            rules={[
                                                                ...ValidationUtility.If(
                                                                    this.state.selectedPaymentMethod == PaymentMethod.BrokerageTransfer || this.state.selectedPaymentMethod == PaymentMethod.MarginLoans,
                                                                    ValidationUtility.required('Comment is required')
                                                                ),
                                                            ]}
                                                            name="comments" //getFieldDecorator(name: { hidden: true })
                                                            label="Comment">
                                                            <TextArea rows={3} placeholder={this.state.commentText} />
                                                        </FormControl>

                                                    </div>
                                                    {/*<div style={this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.OnlineTransfer ? {} : { display: 'none' }}>*/}
                                                    <div style={this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.Transfer ? {} : { display: 'none' }}>

                                                        <FormControl
                                                            getFieldDecorator={getFieldDecorator}
                                                            rules={[
                                                                ...ValidationUtility.If(
                                                                    /*this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.OnlineTransfer,*/
                                                                    this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.Transfer,
                                                                    ValidationUtility.required(
                                                                        'Proof of Payment needs to be uploaded'
                                                                    )
                                                                ),
                                                            ]}
                                                            name="proofOfPayment"
                                                            label="Upload Proof Of Payment">
                                                            <SimpleUpload>
                                                                <Button>
                                                                    <Icon type="upload" /> Click to Upload Proof of Payment
                                                                </Button>
                                                            </SimpleUpload>
                                                        </FormControl>
                                                    </div>


                                                    <Col xs={24} style={{ textAlign: 'center', paddingBottom: '10px' }}> <Title level={4}>- Payment Mandates -</Title> </Col>
                                                    <Col>
                                                        <CenterAlignedRow>
                                                            <Button onClick={() => { this.setState({ showNewPaymentMandate: true }, () => { this.props.form.resetFields(["paymentMandateId"]); }); }}>Add Payment Mandate </Button>
                                                        </CenterAlignedRow>
                                                    </Col>
                                                    <FormControl
                                                        getFieldDecorator={getFieldDecorator}
                                                        rules={[...ValidationUtility.If(!this.state.showNewPaymentMandate, ValidationUtility.required('Payment Mandate is required'))]}
                                                        name="paymentMandateId" //getFieldDecorator(name: { hidden: true })
                                                        label="Payment Mandate">
                                                        <SimpleSelect
                                                            onChange={this.changePaymentMandate}
                                                            options={this.state.paymentMandates}
                                                            placeholder="Please select a payment mandate"></SimpleSelect>
                                                    </FormControl>


                                                    {this.state.showNewPaymentMandate ?
                                                        <>
                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[
                                                                    ...ValidationUtility.If(
                                                                        /*this.state.selectedPaymentMethod == PaymentMethod.ElectronicFundTransfer || this.state.selectedPaymentMethod == PaymentMethod.OnlineTransfer,*/
                                                                        this.state.showNewPaymentMandate,
                                                                        ValidationUtility.required('Bank Name is required')
                                                                    ),
                                                                ]}
                                                                name="paymentMandateBank" //getFieldDecorator(name: { hidden: true })
                                                                label="Bank Name">
                                                                <SimpleSelect
                                                                    options={this.state.banks}
                                                                    placeholder="Please select a Bank"></SimpleSelect>
                                                            </FormControl>

                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[
                                                                    ...ValidationUtility.If(
                                                                        this.state.showNewPaymentMandate,
                                                                        ValidationUtility.required('Branch Name is required')
                                                                    ),
                                                                ]}
                                                                name="paymentMandateBranch" //getFieldDecorator(name: { hidden: true })
                                                                label="Branch Name">
                                                                <Input />
                                                            </FormControl>

                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[
                                                                    ...ValidationUtility.If(
                                                                        this.state.showNewPaymentMandate,
                                                                        ValidationUtility.required('Account Number is required')
                                                                    ),
                                                                ]}
                                                                name="paymentMandateAccountNumber" //getFieldDecorator(name: { hidden: true })
                                                                label="Account Number">
                                                                <Input />
                                                            </FormControl>

                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[
                                                                    ...ValidationUtility.If(
                                                                        this.state.showNewPaymentMandate,
                                                                        ValidationUtility.required('Name on Account is required')
                                                                    ),
                                                                ]}
                                                                name="paymentMandateNameOnAccount" //getFieldDecorator(name: { hidden: true })
                                                                label="Name on Account">
                                                                <Input />
                                                            </FormControl>

                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[
                                                                    ...ValidationUtility.If(
                                                                        this.state.showNewPaymentMandate,
                                                                        ValidationUtility.required('Account Type is required')
                                                                    ),
                                                                ]}
                                                                name="paymentMandateAccountType" //getFieldDecorator(name: { hidden: true })
                                                                label="Account Type">
                                                                <SimpleSelect
                                                                    options={[{ text: "Savings", value: "Savings" }, { text: "Chequing", value: "Chequing" }]}
                                                                    placeholder="Please select an account type"></SimpleSelect>
                                                            </FormControl>
                                                            <FormControl
                                                                getFieldDecorator={getFieldDecorator}
                                                                rules={[
                                                                    ...ValidationUtility.If(
                                                                        this.state.showNewPaymentMandate,
                                                                        ValidationUtility.required('Account Currency is required')
                                                                    ),
                                                                ]}
                                                                name="paymentMandateCurrency" //getFieldDecorator(name: { hidden: true })
                                                                label="Account Currency">
                                                                <SimpleSelect
                                                                    options={[{ text: "JMD", value: "JMD" }, { text: "USD", value: "USD" }]}
                                                                    placeholder="Please select a currency"></SimpleSelect>
                                                            </FormControl>
                                                        </>
                                                        : ''}


                                                    <FormControl
                                                        wrapperCol={{ xs: { offset: 1, span: 20 } }}
                                                        getFieldDecorator={getFieldDecorator}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                transform: value => value || undefined,
                                                                type: 'boolean',
                                                                message: 'You must agree to the disclaimer.',
                                                            },
                                                        ]}
                                                        label=""
                                                        name="agreement" //getFieldDecorator(name: { hidden: true })
                                                    >
                                                        <p className="text-content-justified">
                                                            <u>Disclaimer</u> <br />
                                                            <Checkbox>
                                                                I/We confirm that I/we have read and understood and hereby agree to be bound by the terms
                                                                and conditions in the prospectus for the offer all of which are incorporated in this application by
                                                                reference. I/We agree to accept the same or any smaller number of shares in respect of which
                                                                this application may be accepted, subject to the terms and conditions in the prospectus for this
                                                                offer and the Articles of Incorporation of <b>{this.state.offering?.title}</b>, by which I/we
                                                                agree to be bound. I/We request to transfer to me/us the number of shares which may be
                                                                allocated to me/us at the close of the said invitation based on the terms and conditions
                                                                governing applications, as set forth in the Prospectus. I/We hereby agree to accept the shares
                                                                that may be allocated to me/us to be credited to an account in my/our name(s) in the Jamaica
                                                                Central Securities Depository (JCSD). I/we agree that any refund due after my/our shares are
                                                                allocated shall be placed to my/our brokerage account used for this order. All joint holders must
                                                                sign for this order to be processed.

                                                            </Checkbox>
                                                        </p>
                                                    </FormControl>

                                                    <FormControl
                                                        wrapperCol={{ xs: { offset: 1, span: 20 } }}
                                                        getFieldDecorator={getFieldDecorator}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                transform: value => value || undefined,
                                                                type: 'boolean',
                                                                message: 'You must agree to the privacy policy.',
                                                            },
                                                        ]}
                                                        label=""
                                                        name="privacyAgreement" //getFieldDecorator(name: { hidden: true })
                                                    >
                                                        <p className="text-content-justified">
                                                            <u>Privacy Policy</u> <br />
                                                            <Checkbox>
                                                                I/We also confirm that I/we have read and understood and hereby agree to be bound by the <a href={PrivacyDoc} target="_blank">Privacy Policy</a> and the <a href={TcDoc} target="_blank">Terms
                                                                    and Conditions</a> of the Wealth IPO Edge.
                                                            </Checkbox>
                                                        </p>
                                                    </FormControl>


                                                    {this.state.offering?.refundInstructions ?
                                                        <FormControl
                                                            wrapperCol={{ xs: { offset: 1, span: 20 } }}
                                                            getFieldDecorator={getFieldDecorator}

                                                            label=""
                                                            name="refund" //getFieldDecorator(name: { hidden: true })
                                                        >
                                                            <p className="text-content-justified">
                                                                {this.state.offering?.refundInstructions}
                                                            </p>
                                                        </FormControl> : ''}




                                                    <RightAlignedRow>
                                                        <Col>
                                                            <BrandedButton htmlType="submit" disabled={this.state.selectedPaymentMethod != undefined}
                                                                style={{ marginRight: '10px' }}>
                                                                SAVE
                                                            </BrandedButton>
                                                            <BrandedButton htmlType="submit" disabled={!this.state.selectedPaymentMethod} >
                                                                SUBMIT
                                                            </BrandedButton>
                                                        </Col>
                                                    </RightAlignedRow>
                                                </StyleIpoApplicationForm>
                                                <Modal
                                                    title=""
                                                    centered
                                                    visible={this.state.showModal}
                                                    onOk={this.handleOk}
                                                    onCancel={this.handleCancel}
                                                    footer={[
                                                        <Button key="back" onClick={this.handleCancel}>
                                                            Cancel
                                                        </Button>,
                                                        <Button key="submit" type="primary" onClick={this.handleOk} form="fiservForm" >
                                                            Submit
                                                        </Button>,
                                                    ]}
                                                >
                                                    <>


                                                        <p style={{ fontWeight: 'bolder' }} className="text-content-justified">
                                                            Take a picture of written or digital signature on a blank screen/background.
                                                            Illegible signatures may delay processing of application     </p>
                                                        {
                                                            this.state.jointHolder1 ?
                                                                <>

                                                                    <FormControl getFieldDecorator={getFieldDecorator}
                                                                        rules={[...ValidationUtility.If(this.state.jointHolder1 !== undefined, ValidationUtility.required('Signature is required'))]}
                                                                        labelAlign={"left"}
                                                                        labelCol={{ sm: { span: 24 } }} wrapperCol={{ sm: { span: 10 } }}
                                                                        label={"Signature for " + this.state.jointHolder1?.fullName} name="signatureFile1">
                                                                        <SimpleUpload accept={'image/*,.pdf'} >
                                                                            <Button>
                                                                                <Icon type="upload" /> Click to Upload
                                                                            </Button>
                                                                        </SimpleUpload>
                                                                        {/*        <Upload accept={'image/*,.pdf'} listType={'picture'} onRemove={file => { file.status = 'removed'}}*/}
                                                                        {/*            >*/}
                                                                        {/*        <Button>*/}
                                                                        {/*            <Icon type="upload" /> Click to Upload*/}
                                                                        {/*</Button>*/}
                                                                        {/*    </Upload>*/}
                                                                        {/*    <SimpleUpload accept={'image/*,.pdf'} value={[{*/}
                                                                        {/*        uid: '-1',*/}
                                                                        {/*        name: 'xxx.png',*/}
                                                                        {/*        status: 'done',*/}
                                                                        {/*        size: 50,*/}
                                                                        {/*        type: 'text',*/}
                                                                        {/*        url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',*/}
                                                                        {/*        thumbUrl: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',*/}
                                                                        {/*    }]}>*/}
                                                                        {/*        <Button>*/}
                                                                        {/*            <Icon type="upload" /> Click to Upload*/}
                                                                        {/*</Button>*/}
                                                                        {/*    </SimpleUpload>*/}
                                                                    </FormControl> </> : ''
                                                        }
                                                        {
                                                            this.state.jointHolder2 ?
                                                                <FormControl getFieldDecorator={getFieldDecorator}
                                                                    rules={[...ValidationUtility.If(this.state.jointHolder2 !== undefined, ValidationUtility.required('Signature is required'))]}
                                                                    labelAlign={"left"}
                                                                    labelCol={{ sm: { span: 24 } }} wrapperCol={{ sm: { span: 10 } }}
                                                                    label={"Signature for " + this.state.jointHolder2?.fullName} name="signatureFile2">
                                                                    <SimpleUpload accept={'image/*,.pdf'} >
                                                                        <Button>
                                                                            <Icon type="upload" /> Click to Upload
                                                                        </Button>
                                                                    </SimpleUpload>
                                                                </FormControl> : ''
                                                        }
                                                        {
                                                            this.state.jointHolder3 ?
                                                                <FormControl getFieldDecorator={getFieldDecorator}
                                                                    rules={[...ValidationUtility.If(this.state.jointHolder3 !== undefined, ValidationUtility.required('Signature is required'))]}
                                                                    labelAlign={"left"}
                                                                    labelCol={{ sm: { span: 24 } }} wrapperCol={{ sm: { span: 10 } }}
                                                                    label={"Signature for " + this.state.jointHolder3?.fullName} name="signatureFile3">
                                                                    <SimpleUpload accept={'image/*,.pdf'}>
                                                                        <Button>
                                                                            <Icon type="upload" /> Click to Upload
                                                                        </Button>
                                                                    </SimpleUpload>
                                                                </FormControl> : ''
                                                        }
                                                        {
                                                            this.state.jointHolder4 ?
                                                                <FormControl getFieldDecorator={getFieldDecorator}
                                                                    rules={[...ValidationUtility.If(this.state.jointHolder4 !== undefined, ValidationUtility.required('Signature is required'))]}
                                                                    labelAlign={"left"}
                                                                    labelCol={{ sm: { span: 24 } }} wrapperCol={{ sm: { span: 10 } }}
                                                                    label={"Signature for " + this.state.jointHolder4?.fullName} name="signatureFile4">
                                                                    <SimpleUpload accept={'image/*,.pdf'}>
                                                                        <Button>
                                                                            <Icon type="upload" /> Click to Upload
                                                                        </Button>
                                                                    </SimpleUpload>
                                                                </FormControl> : ''
                                                        }
                                                    </>
                                                </Modal>
                                                <Modal
                                                    title=""
                                                    centered
                                                    visible={this.state.showFiservModal}
                                                    onOk={undefined}
                                                    onCancel={this.handleCancel}
                                                    footer={[]}
                                                >
                                                    <>
                                                        {this.state.paymentInfo ?
                                                            <>
                                                                <p style={{ fontWeight: 'bolder' }} className="text-content-justified">
                                                                    Your IPO application has been submitted. You will now be redirected to complete your card payment.</p>
                                                                <form method="POST" action={this.state.paymentInfo?.fiservUrl} onSubmit={this.getFiserv} id="fiservForm">
                                                                    {
                                                                        Object.entries(this.state.paymentInfo.formParameter ?? {})
                                                                            .map(key => {
                                                                                return <input type="hidden" value={key[1] as string} name={key[0]} />
                                                                            })
                                                                    }
                                                                    <input type="hidden" value={this.state.paymentInfo.hashExtended} name='hashExtended' />
                                                                    <Button type="primary" htmlType="submit" style={{ display: 'block' }} >Proceed</Button>
                                                                </form>
                                                            </>
                                                            : ''}
                                                    </>
                                                </Modal>
                                                <Modal
                                                    title=""
                                                    centered
                                                    visible={this.state.showDocumentsModal}
                                                    onOk={this.handleAccreditationOk}
                                                    onCancel={this.handleCancel}
                                                    footer={[
                                                        <Button key="back" onClick={this.handleCancel}>
                                                            Cancel
                                                        </Button>,
                                                        <Button key="submit" type="primary" onClick={this.handleAccreditationOk} >
                                                            Submit
                                                        </Button>,
                                                    ]}
                                                >
                                                    <p style={{ fontWeight: 'bolder' }} className="text-content-justified">
                                                        Please download, complete and upload the attached
                                                        investor documents where necessary.
                                                    </p>

                                                    {
                                                        this.state.offering?.documents?.map((item, i) => {

                                                            return <>
                                                                <FormControl getFieldDecorator={getFieldDecorator}
                                                                    rules={[...ValidationUtility.If((item.requiresClientUpload ?? false), ValidationUtility.required('Upload is required'))]}
                                                                    labelAlign={"left"}
                                                                    labelCol={{ sm: { span: 24 } }} wrapperCol={{ sm: { span: 10 } }}
                                                                    label={<><a onClick={x => { this.DownloadLink(item?.document?.fileUrl); x.preventDefault(); }}><u>Download</u></a> {item.displayName}</>}
                                                                    name={"documents[" + i + "].document"}>
                                                                    <SimpleUpload accept={'image/*,.pdf'} onChange={(e) => { this.updateUploadedDocument(item.documentId, e); }}>
                                                                        <Button>
                                                                            <Icon type="upload" /> Click to Upload
                                                                        </Button>
                                                                    </SimpleUpload>
                                                                </FormControl>
                                                            </>
                                                        })
                                                    }

                                                </Modal>

                                                <Modal
                                                    title=""
                                                    centered
                                                    visible={this.state.showPaymentMandateModal}
                                                    onOk={this.handlePaymentReview}
                                                    onCancel={this.handleCancel}
                                                    footer={[
                                                        <Button key="back" onClick={this.handleCancel}>
                                                            Cancel
                                                        </Button>,
                                                        <Button key="submit" type="primary" onClick={this.handlePaymentReview} >
                                                            Submit
                                                        </Button>,
                                                    ]}
                                                >
                                                    <p style={{ fontWeight: 'bolder' }} className="text-content-justified">
                                                        Please review your payment mandate details below:
                                                    </p>
                                                    <Row>
                                                        <Col xs={{ span: 23, offset: 1 }} sm={{ span: 11, offset: 1 }}>
                                                            <BorderlessDescriptions bordered column={1}>
                                                                <Descriptions.Item label="Bank">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.selectedPaymentMandate ? this.state.selectedPaymentMandate?.bank : ''}
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Branch">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.selectedPaymentMandate ? this.state.selectedPaymentMandate?.branch : ''}
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Name on Account">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.selectedPaymentMandate ? this.state.selectedPaymentMandate?.nameOnAccount : ''}
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Account Number">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.selectedPaymentMandate ? this.state.selectedPaymentMandate?.accountNumber : ''}
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Account Type">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.selectedPaymentMandate ? this.state.selectedPaymentMandate?.accountType : ''}
                                                                    </div>
                                                                </Descriptions.Item>
                                                                <Descriptions.Item label="Currency">
                                                                    <div style={{ fontWeight: 'bolder' }}>
                                                                        {this.state.selectedPaymentMandate ? this.state.selectedPaymentMandate?.currency : ''}
                                                                    </div>
                                                                </Descriptions.Item>
                                                            </BorderlessDescriptions>

                                                        </Col>
                                                    </Row>
                                                </Modal>

                                                <Modal
                                                    title="Please Note"
                                                    centered
                                                    visible={this.state.showAccreditationModal}
                                                    onCancel={this.handleCancel}
                                                    footer={[
                                                        <Button key="back" onClick={this.handleCancel}>
                                                            Ok
                                                        </Button>,
                                                    ]}>
                                                    <p style={{ fontWeight: 'normal' }} className="text-content-justified">
                                                        This Offer is only for Accredited investors or investors purchasing
                                                        a minimum of J$10,000,000.00. As per FSC guidelines each client
                                                        investing below the minimum of J$10,000,000.00 must download,
                                                        complete, and upload the Accredited Investor Questionnaire when
                                                        submitting each application. <b> All applications where required
                                                            information or documents are not provided will be rejected without
                                                            prejudice.</b>
                                                    </p>
                                                </Modal>

                                                <Modal
                                                    title="Important Notice: Update to Payment Procedures"
                                                    centered
                                                    visible={this.state.showPseudoNotice}
                                                    onCancel={this.handleCancel}
                                                    footer={[
                                                        <Button key="back" onClick={this.handleCancel}>
                                                            Ok
                                                        </Button>,
                                                    ]}>
                                                    <p style={{ fontWeight: 'normal' }} className="text-content-justified">
                                                        Please <b>DO NOT</b> transfer any funds to our NCB accounts.
                                                        <br/>
                                                        <br/>
                                                        Kindly use the account information provided in the payment method details of the offer.
                                                    </p>
                                                </Modal>

                                            </Col>
                                        </Row>
                                    </Col>
                                </LeftAlignedRow>
                            </Col>
                        </Row>
                    </WhiteBackgroundCard>
                </Col>
            </Row>
        );
    }

    private ShouldRedirectTo(state: { from?: any; noPermission?: boolean | undefined }): boolean {
        return !!state.from && state.from.pathname !== '/logout';
    }
}

const IpoApplicationFormWithoutRouter = Form.create<Props>({
    name: 'Confirm',
})(IpoApplicationFormWithoutFormAndRouter);

const IpoApplicationForm = withRouter(IpoApplicationFormWithoutRouter);

export default IpoApplicationForm;
